import { Form } from 'react-bootstrap';

import withSiteLoader from '../containers/withsiteloader';


function SiteSelector(props) {

  return (
    <Form.Select
      name="site_name"
      value={props.site_name || ''}
      onChange={props.onChange}
    >
      <option value="">Seleccionar sitio</option>
      {
        props.sites.map((e) => (
          <option key={e.id} value={e.name}>{e.name}</option>
        ))
      }
    </Form.Select>
  );
}


export default withSiteLoader(SiteSelector);
